import { useLanguage } from "../../../../contexts/LanguageContext"
import CollapsibleCategory from "./CollapsibleCategory"

/**
 * Step-by-step section with collapsible categories.
 * Renders the step-by-step guide section with predefined categories and items.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters containing step-by-step label
 * @returns {JSX.Element}
 */
export default function StepByStepSection({ parameters }) {
  const { t } = useLanguage()

  const stepByStepCategories = [
    {
      title: t("AssistantWindow.assistantWindowSbsCategory"),
      items: [
        t("AssistantWindow.assistantWindowSbsCategoryExample1"),
        t("AssistantWindow.assistantWindowSbsCategoryExample2"),
        t("AssistantWindow.assistantWindowSbsCategoryExample3"),
      ],
      id: "shortwaysSbs0",
    },
    {
      title: t("AssistantWindow.assistantWindowSbsMisc"),
      items: [
        t("AssistantWindow.assistantWindowSbsMiscExample1"),
        t("AssistantWindow.assistantWindowSbsMiscExample2"),
        t("AssistantWindow.assistantWindowSbsMiscExample3"),
        t("AssistantWindow.assistantWindowSbsMiscExample4"),
      ],
      id: "shortwaysSbs1",
    },
  ]

  return (
    <div className="welcomeLineDiv welcomeSbs">
      <span id="mainPopupSbsFile" data-testid="mainPopupSbsFile" className="btn shortwaysIcon sbsIcon" />
      <span id="sbsLabel" className="welcomeTitle">
        {parameters.sbsLabel || t("Text.textSbsInput")}
      </span>
      <div className="categoryTitle">
        <div className="welcomeLineDiv">
          <div className="shortwaysDocList">
            {stepByStepCategories.map(category => (
              <CollapsibleCategory key={category.id} title={category.title} items={category.items} categoryId={category.id} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
